export const iframe = {
  attrs: {
    src: {
      default: null,
    },
    style: {
      default: null,
    },
    id: {
      default: null,
    },
  },
  group: "block",
  selectable: false,
  parseDOM: [
    {
      tag: "iframe",
      getAttrs: (dom) => ({
        src: dom.getAttribute("src"),
        style: dom.getAttribute("style"),
        id: dom.getAttribute("id"),
      }),
    },
  ],
  toDOM: (node) => {
    const attrs = {
      src: node.attrs.src,
      style: node.attrs.style,
      id: node.attrs.id,
      frameborder: "0",
      allowfullscreen: "true",
    };
    return ["iframe", attrs];
  },
};
